
export { ModalService } from "/home/runner/work/capsicum/capsicum/libs/common-web/services/index.ts"
export { useInfoModal } from "/home/runner/work/capsicum/capsicum/libs/common-web/hooks/index.ts"